import React, { useCallback, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { auth } from "../../../utils/auth";
import { request } from "../../../utils/request";
import dayjs from "dayjs";

const Print = () => {
    const [visitas, setVisitas] = useState([]);

    const location = useLocation();
	const queryParams = new URLSearchParams(location.search);
    const user = auth.getUser();
    const sucursal = user.sucursales.filter(
        (suc) => suc.id === user.sucursalActual
    )[0];

    const getVisitas = useCallback(() => {
		request(`salud/visitas${location.search}`).then((res) => {
			setVisitas(res.data);
		});
	}, [location]);

    useEffect(() => {
        getVisitas();
    }, []);

    useEffect(() => {
        if (visitas.length === 0) return;

        const timeout = setTimeout(() => {
            window.print();
        }, 1000);

        return () => {
            clearTimeout(timeout);
        };
    }, [visitas]);

    return <>
        <div className="row">
            <h2 className="col-md-12 text-center m-b-5">
                Reporte Visitas
            </h2>
            <div className="col-md-12 text-center">
                {sucursal.nombre} - {sucursal.direccion} •{" "}
                {queryParams.get("desde")
                    ? `${dayjs(queryParams.get("desde")).format(
                            "DD/MM/YYYY"
                        )} - `
                    : ""}{" "}
                {dayjs(queryParams.get("hasta")).format("DD/MM/YYYY")}
            </div>
        </div>

        <div className="row mt-5 ml-2">
            <table className="table m-b-15">
                <thead>
                    <tr>
                        <th>Paciente</th>
                        <th>Tipo Contacto</th>
                        <th>Motivo</th>
                        <th>Tipo de Visita</th>
                        <th>Observaciones</th>
                        <th>Signos</th>
                        <th>Diagnóstico</th>
                        <th>Derivación EXterna</th>
                    </tr>
                </thead>

                <tbody>
                    {visitas.map((visita) => <tr key={visita.id}>
                        <td>{visita.paciente.nombre_completo}</td>
                        <td>{visita.paciente.tipo}</td>
                        <td>{visita.motivo.descripcion}</td>
                        <td>{visita.tipo}</td>
                        <td style={{maxWidth: '256px', padding: '5px', overflowWrap: 'break-word'}}>{visita.observaciones}</td>
                        <td style={{width: '160px', padding: '5px'}}>
                            {Object.entries(visita.signos).map(([key, value]) => (
                                <div className="row" key={key}>
                                    <div className="capitalize" style={{width: '100px'}}><strong>{key}</strong></div>
                                    <div className="col text-right">{value}</div>
                                </div>
                            ))}
                        </td>
                        <td style={{maxWidth: '256px', padding: '5px', overflowWrap: 'break-word'}}>{visita.diagnostico}</td>
                        <td>{visita.derivacion ? 'Sí' : 'No'}</td>
                    </tr>)}
                </tbody>
            </table>
        </div>

        <style type="text/css" media="print">
            @page {"{ size: landscape; }"}
        </style>
    </>;
};

export default Print;